export default "__VITE_ASSET__393ee2ba__"